import Layout from '@/layout/index'

/**
 * 注意：子菜单仅在路由子菜单时显示。长度>=1
 *
 * hidden: true                   如果设置为true，则该项将不会显示在侧边栏中（默认为false）
 * alwaysShow: true               如果设置为true，将始终显示根菜单
 *                                如果未设置alwaysShow，则当项目在路线中有多个子项时，
 *                                它将变为嵌套模式，否则不显示根菜单
 * redirect: noRedirect           重定向：noRedirect如果设置noRedirect，则面包屑中不会重定向
 * name:'router-name'             名称：'router-name'名称由＜keep-alive＞使用（必须设置！！！）
 * meta : {
    title: 'title'               侧边栏和面包屑中显示的名称（推荐设置）
    icon: 'svg-name'/'el-icon-x' 侧边栏中显示的图标
    noCache: true                如果设置为true，则不会缓存页面（默认为false）
    breadcrumb: false            如果设置为false，则该项将隐藏在面包屑中（默认为true）
    activeMenu: '/example/list'  如果设置路径，侧边栏将突出显示您设置的路径
  }
 */

var router = [
    {/* 首页 */
        path: '/',
        component: Layout,
        redirect: '/Home',
        meta: { title: 'Home', icon: 'home' },
        children: [
            {
                path: 'Home',
                component: () => import('@/views/Home'),
                name: 'Home',
                meta: { title: 'Home', icon: 'home' }
            },
        ]
    },
    {
        path: '/Search',
        component: Layout,
        redirect: '',
        meta: { title: 'Search', icon: 'Search' },
        children: [
            {
                path: '',
                component: () => import('@/views/Search'),
                name: 'Search',
                meta: { title: 'Search', icon: 'Search' }
            },
        ]
    },
    {
        path: '/Blast',
        component: Layout,
        redirect: '',
        meta: { title: 'Blast', icon: 'Blast' },
        children: [
            {
                path: '',
                component: () => import('@/views/Blast'),
                name: 'Blast',
                meta: { title: 'Blast', icon: 'blast' }
            },
        ]
    },
    {
        path: '/Browse',
        component: Layout,
        redirect: '',
        meta: { title: 'Browse', icon: 'browse' },
        children: [
            {
                path: '',
                component: () => import('@/views/Browse'),
                name: 'Browse',
                meta: { title: 'Browse', icon: 'browse' }
            },
        ]
    },
    {
        path: '/LncRNA',
        component: Layout,
        redirect: '/LncRNA',
        meta: { title: 'LncRNA', icon: 'lncRNA' },
        children: [
            {
                path: '/LncRNA',
                component: () => import('@/views/LncRNA/LncRNA'),
                name: 'LncRNA Search',
                meta: { title: 'LncRNA Search' }
            },
            {
                path: '/EncodingSkin',
                component: () => import('@/views/LncRNA/EncodingSkin'),
                name: 'Encoding skin',
                meta: { title: 'Encoding skin' }
            },
            {
                path: '/IDConversion',
                component: () => import('@/views/LncRNA/IDConversion'),
                name: 'ID Conversion',
                meta: { title: 'ID Conversion' }
            },
        ]
    },
    {
        path: '/GWAS',
        component: Layout,
        redirect: '',
        meta: { title: 'GWAS', icon: 'GWAS' },
        children: [
            {
                path: '',
                component: () => import('@/views/GWAS'),
                name: 'GWAS',
                meta: { title: 'GWAS', icon: 'GWAS' }
            },
        ]
    },
    {
        path: '/Network',
        component: Layout,
        redirect: '/lncRNA-gene-trait',
        meta: { title: 'Network', icon: 'network' },
        children: [
            {
                path: '/lncRNA-gene-trait',
                component: () => import('@/views/Network/lncRNA-gene-trait'),
                name: 'lncRNA-Gene-Trait',
                meta: { title: 'lncRNA-Gene-Trait' }
            },
            {
                path: '/CisTrans',
                component: () => import('@/views/Network/CisTrans'),
                name: 'Cis Trans',
                meta: { title: 'Cis Trans' }
            },
            {
                path: '/lncRNA-mRNA-miRNA',
                component: () => import('@/views/Network/lncRNA-mRNA-miRNA'),
                name: 'lncRNA-mRNA-miRNA',
                meta: { title: 'lncRNA-mRNA-miRNA' }
            },
        ]
    },
    {
        path: '/Download',
        component: Layout,
        redirect: '',
        meta: { title: 'Download', icon: 'download' },
        children: [
            {
                path: '',
                component: () => import('@/views/Download'),
                name: 'Download',
                meta: { title: 'Download', icon: 'download' }
            },
        ]
    },
    {
        path: '/Contact',
        component: Layout,
        redirect: '',
        meta: { title: 'Contact', icon: 'Contact' },
        children: [
            {
                path: '',
                component: () => import('@/views/Contact'),
                name: 'Contact',
                meta: { title: 'Contact', icon: 'Contact' }
            },
        ]
    },
]
export default router